package component

import com.github.quillraven.fleks.*
import com.soywiz.kds.*
import models.*
import system.network.*

class PhysicSnapshotStateComponent : Component<PhysicSnapshotStateComponent> {

    val snapshots = Queue<StateSnapshot>()

    override fun type() = PhysicSnapshotStateComponent

    companion object : ComponentType<PhysicSnapshotStateComponent>()
}
